import { render } from "./toolsedit.vue?vue&type=template&id=4c17fc27"
import script from "./toolsedit.vue?vue&type=script&lang=js"
export * from "./toolsedit.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__